import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../lib/firebase";

/**
 * Upload a Blob to Firebase Storage and return the resolved download URL.
 *
 * Used by the ImageUpload and PdfUpload components for the direct-upload
 * paths (event hero, sponsor logo, session materials). The speaker-photo
 * path goes through the setUserPhotoOnBehalf callable instead — see
 * userPhotoService.ts.
 *
 * Storage security is enforced server-side by storage.rules; this helper
 * does not duplicate those checks.
 */
export async function uploadToStorage(
  path: string,
  blob: Blob,
  contentType: string,
): Promise<string> {
  const ref = storageRef(storage, path);
  await uploadBytes(ref, blob, { contentType });
  return getDownloadURL(ref);
}

/**
 * Generate a unique filename with a Date.now() prefix and a random suffix.
 * Used for storage paths so concurrent uploads don't collide.
 */
export function generateStorageFilename(extension: string): string {
  const random = Math.random().toString(36).slice(2, 10);
  return `${Date.now()}-${random}.${extension.replace(/^\./, "")}`;
}
